export class CodeTransformer {
  static transform(obj) {
    let code = {};

    code.id = obj.id;
    code.name = obj.attributes.name;
    code.code = obj.attributes.code;

    return code;
  }
}
